export const hexToRgb = (hex) => {
  // Remove the leading '#' if present
  hex = hex?.replace(/^#/, "");

  // Parse the hex value into its RGB components
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;

  return `${r}, ${g}, ${b}`;
};

/**
 * Lightens a hex color by a given percentage towards white. 
 * 
    const original = "#E31937";
    const lightened = lightenColor(original, 0.85); // 85% towards white
    console.log(lightened); // Output: ~#FFE4E8
 */
export function lightenColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  const r = (num >> 16) + Math.round((255 - (num >> 16)) * percent);
  const g =
    ((num >> 8) & 0x00ff) + Math.round((255 - ((num >> 8) & 0x00ff)) * percent);
  const b = (num & 0x0000ff) + Math.round((255 - (num & 0x0000ff)) * percent);

  return (
    "#" +
    ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()
  );
}
